module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/global_map_bg_with_news_with_quests_big_cn.0976ea59.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/global_map_bg_with_news_with_quests_big_cn.jpg
// module id = 2984
// module chunks = 11